import Backbone from 'backbone';
import Promise from 'bluebird';

export type StateKey = string;
export type StateValue = unknown;

export interface StateModel extends Backbone.Model {
  getPromise<TValue = StateValue>(key: StateKey): Promise<TValue>;
}

type BackboneModelExtend = {
  extend(properties: Backbone.ObjectHash, classProperties?: Backbone.ObjectHash): new (...args: unknown[]) => StateModel;
};

var State = (Backbone.Model as unknown as BackboneModelExtend).extend({
  getPromise: function <TValue = StateValue>(this: Backbone.Model, key: StateKey): Promise<TValue> {
    if (this.has(key)) {
      return Promise.resolve(this.get(key) as TValue);
    } else {
      return new Promise<TValue>((function (this: Backbone.Model, resolve: (value: TValue) => void) {
        this.once('change:' + key, function (model: Backbone.Model, value: TValue) {
          resolve(value);
        });
      }).bind(this));
    }
  }
});
export default new State();
